/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { toast } from "react-toastify";


import {useNavigate, useParams } from "react-router-dom";

import {
    ALLOCATED_INVENTORY,
    ASSIGN_HISTORY,
} from "../../../repository/taskRepo";
import moment from "moment";

const useHistory = () => {
  const navigate = useNavigate();
  const [spinner, setSpinner] = useState(false);
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
  const [totalCount, setTotalCount] = useState(0);
  const [assignHistory, setAssignHistory] = useState([]);
  const [productDetails, setProductDetails] = useState("")
   const { id } = useParams();
  

  const handlePagination = (obj) => {
    setController(obj);
  };

  useEffect(() => {
    assignHistoryData();
    allocatedInventoryData()
  }, [controller.page, controller.rowsPerPage]);

const fetchMoreData = () => setController((prev) => prev.rowsPerPage + 10);

  const assignHistoryData = async () => {
    try {
      let payload = {
        count: controller.rowsPerPage,
        page: controller.page,
        type: "INVENTORYSTOCKASSIGN",
        type_id: id,
      };
      setSpinner(true);
      let response = await ASSIGN_HISTORY(payload);
      setAssignHistory(response?.data);
      setTotalCount(response?.totalCount || 0);
    } catch (error) {}
    setSpinner(false);
  };

   const allocatedInventoryData = async () => {
    try {
      let payload = {
        _id: id,
      };
      setSpinner(true);
      let response = await ALLOCATED_INVENTORY(payload);
      setProductDetails(response?.data);
    } catch (error) {}
    setSpinner(false);
  };


  return {
    data: {
      spinner,
      controller,
      totalCount,
      assignHistory,
      productDetails
    },
    methods: {
      handlePagination,
      fetchMoreData
    },
  };
};

export default useHistory;
